"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LvToAllianzUKTransferBannerHelper = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
class LvToAllianzUKTransferBannerHelper {
    static setBannerWidgetState(settings, setState) {
        if ((settings.lvToAllianzTransferBannerEnabled && !settings.lvToAllianzTransferWording) || !settings.lvToAllianzTransferBannerEnabled) {
            setState({ isBannerEnabled: false });
            return;
        }
        const effectiveWording = settings.lvToAllianzTransferWording.find(wording => {
            if (!wording.effectiveDate || !wording.effectiveEndDate) {
                return false;
            }
            return (0, moment_timezone_1.default)().tz(this.TIMEZONE).isBetween(this.parseDate(wording.effectiveDate), this.parseDate(wording.effectiveEndDate));
        });
        if (!effectiveWording) {
            setState({ isBannerEnabled: false });
            console.error(`No effective banner configuration found! Found configurations: ${settings.lvToAllianzTransferWording.length}`);
            return;
        }
        setState({
            isBannerEnabled: !!effectiveWording.wording,
            wording: effectiveWording.wording
        });
    }
    static parseDate(stringDate) {
        return moment_timezone_1.default.tz(stringDate, ["YYYY-MM-DD HH:mm", "YYYY-MM-DD HH:mm:ss"], this.TIMEZONE);
    }
}
exports.LvToAllianzUKTransferBannerHelper = LvToAllianzUKTransferBannerHelper;
LvToAllianzUKTransferBannerHelper.TIMEZONE = "Europe/London";
//# sourceMappingURL=LvToAllianzUKTransferBannerHelper.js.map